import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

export const breadcrumbStyle = {
    maxWidth: pxToRem(1400),
    width: '100%',
    marginTop: pxToRem(15),
    marginRight: 'auto',
    marginBottom: [pxToRem(15), pxToRem(15), pxToRem(5), pxToRem(5)],
    marginLeft: 'auto',
    fontSize: pxToRem(14),
    fontWeight: 600,
    fontFamily: fonts.primary,
    lineHeight: pxToRem(20),
    padding: `${pxToRem(8)} ${pxToRem(18)} ${pxToRem(0)} ${pxToRem(18)}`,
    letterSpacing: pxToRem(4),
    textTransform: 'uppercase',
    background: 'transparent',
    '.navBar': {
        margin: `${pxToRem(0)} ${pxToRem(10)}`
    },
    '.link': {
        color: 'black',
        lineHeight: pxToRem(20),
        textDecoration: 'none',
        '&:hover': {
            color: 'cav_red'
        }
    },
    '.breadcrumb-divider': {
        color: 'cav_red'
    },
    '.text': {
        display: 'inline-block',
        lineHeight: pxToRem(20),
        margin: pxToRem(0),
        color: 'black',
        fontSize: pxToRem(14),
        fontWeight: 600,
        fontFamily: fonts.primary,
        letterSpacing: pxToRem(4),
        textTransform: 'uppercase',
        background: 'transparent'
    }
}
